// extracted by mini-css-extract-plugin
export default {"firstSessionModal_container":"Xr","firstSessionModal_header":"Yr","firstSessionModal_title":"Zr","firstSessionModal_header_tex":"as","firstSessionModal_video":"bs","firstSessionModal_videoContent":"cs","firstSessionModal_FAQ":"es","firstSessionModal_FAQMargin":"fs","firstSessionModal_FAQTitle":"gs","firstSessionModal_buttonContainer":"hs","firstSessionModal_buttonText":"is","firstSessionModal_SMSBtn_mob":"js"};
    if(module.hot) {
      // 1715091669565
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  